import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders} from "@angular/common/http";
import { Toast } from '../configs/toast';
import { retry, catchError } from 'rxjs/operators';
import { Observable, firstValueFrom, throwError } from 'rxjs';
import { SwalError400 } from './errors';
import { environment } from '../../../environments/environment';
import { ErrorsService } from './errors.service';

declare var $:any

@Injectable({
    providedIn: 'root'
})
export class RestServiceV2 {
    open() {
      throw new Error('Method not implemented.');
    }
    public url:string = environment.url
    loading:boolean = true
    errorsService = inject(ErrorsService)
    constructor(
        private http:HttpClient,
    ){

    }

    setHeaders = ( file = false):HttpHeaders => {
        let header:any = {
            // Accept: 'application/json',
            // 'Content-Type': 'application/json',
            'Cache-Control' : 'no-cache',
            'Authorization' : `Bearer ${localStorage.getItem('session')}`,
        };
        return new HttpHeaders(header);
    }

    async getFirstValue(rest:Observable<any>, showError:boolean = true, isArrayBuffer:boolean = false):Promise<any>{
        try {
            const response = await firstValueFrom(rest)
            return response
        } catch (error) {
            if (error instanceof HttpErrorResponse) {
                if(showError){
                    console.log(error)
                    // Si es ArrayBuffer, convertir el error a JSON
                    if (isArrayBuffer && error.error instanceof ArrayBuffer) {
                        try {
                            console.log('Es ArrayBuffer')
                            const errorText = new TextDecoder().decode(error.error);
                            const errorJson = JSON.parse(errorText);
                            // Crear un nuevo HttpErrorResponse con el JSON parseado
                            const modifiedError = new HttpErrorResponse({
                                error: errorJson,
                                headers: error.headers,
                                status: error.status,
                                statusText: error.statusText,
                                url: error.url || undefined
                            });
                            console.log(modifiedError)
                            this.errorsService.heddleError(modifiedError);
                        } catch (parseError) {
                            // Si no se puede parsear, usar el error original
                            this.errorsService.heddleError(error);
                        }
                    } else {
                        this.errorsService.heddleError(error);
                    }
                }
                return null
            }
        }
    }

    post = async ( url:string, body:any = {}, headers:any = {}):Promise<any> =>{
        return await this.getFirstValue(
            this.http.post(`${this.url}${url}`,body,{
                headers: this.setHeaders()
            })
        )
    }

    getFile(url:string){
        return this.getFirstValue(
            this.http.get(`${this.url}${url}`,{
                headers: this.setHeaders(true),
                responseType: 'arraybuffer'
            }),
            true, // showError
            true  // isArrayBuffer
        )
    }

    getFilePost(url:string, body:any = {}){
        return this.getFirstValue(
            this.http.post(`${this.url}${url}`,body,{
                headers: this.setHeaders(true),
                responseType: 'arraybuffer'
            }),
            true, // showError
            true  // isArrayBuffer
        )
    }

    patch = async ( url:string, body:any = {}, headers:any = {}):Promise<any> =>{
        return await this.getFirstValue(
            this.http.patch(`${this.url}${url}`,body,{
                headers: this.setHeaders()
            })
        )
    }

    delete = async ( url:string, headers:any = {}):Promise<any> =>{
        return await this.getFirstValue(
            this.http.delete(`${this.url}${url}`,{
                headers: this.setHeaders()
            })
        )
    }

    get = async ( url:string, params = {}, isPaginate:boolean = false, showError:boolean = true  ):Promise<any> => {
        const urlEnd = isPaginate ? url : `${this.url}${url}`
        return await this.getFirstValue(
            this.http.get( urlEnd, {
                headers: this.setHeaders(),
                params:this.eliminarPropiedadesNull(params)
            }),
            showError
        )
    }

    eliminarPropiedadesNull(objeto:any) {
        const nuevoObjeto:any = {};
        for (let clave in objeto) {
          if (objeto.hasOwnProperty(clave) && objeto[clave] !== null) {
            nuevoObjeto[clave] = objeto[clave];
          }
        }
        return nuevoObjeto;
    }
    

     /**
   * Method is use to download file.
   * @param data - Array Buffer data
   * @param type - type of the document.
   */
  downLoadFile(name:string, type: any, data: string) {
    let blob = new Blob([data], { type: type});
    let url = window.URL.createObjectURL(blob);
    let pwa = window.open(url,"Libro ingreso y egreso");
    if (!pwa || pwa.closed || typeof pwa.closed == 'undefined') {
      Toast.fire('Please disable your Pop-up blocker and try again','','info')
    }
  }

    saveFile (name:string, type:any, data:any) { 
        // if (data != null && navigator.msSaveBlob) 
        //  return navigator.msSaveBlob(new Blob([data], { type: type }), name); 
        let a = $("<a style='display: none;'/>"); 
        let url = window.URL.createObjectURL(new Blob([data], {type: type})); 
        a.attr("href", url); 
        a.attr("download", name); 
        $("body").append(a); 
        a[0].click(); 
        window.URL.revokeObjectURL(url); 
        a.remove(); 
    } 

    errorHandl(error:HttpErrorResponse) {
        let errorMessage = '';
        if (error.error instanceof ErrorEvent) {
          // Get client-side error
          errorMessage = error.error.message;
        } else {
          // Get server-side error
          errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        }
        console.log(errorMessage);
        return throwError(() => {
          return errorMessage;
        });
      }
}